module.exports = __webpack_public_path__ + "a90a68d693e5decd04b5aaa939ddb59f.png";